import Vue from 'vue';
import '@/utils/prototype'; // vue 原型拓展
import axios from 'axios';
import md5 from 'js-md5';
import App from './App.vue';
import router from './router';
import store from './store';
import echarts from 'echarts';
import Viewer from 'viewerjs';
// 引入vue-amap
import 'viewerjs/dist/viewer.css';
import './element/element';
import './vant/vant';
import './assets/scss/index.scss';
import './permission';
import utils from '@/utils/utils';


import Vtoggle from '@/components/Vtoggle.vue';
import VTable from '@/components/VTable.vue';

Vue.component(Vtoggle.name, Vtoggle);
Vue.component(VTable.name, VTable);

// import systemComponents from 'system-components';
// import 'system-components/lib/system-components.css';

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$md5 = md5;
Vue.prototype.getButtonListRules = utils.getButtonListRules;
Vue.prototype.$echarts = echarts;
Vue.prototype.Viewer = Viewer;
// Vue.use(systemComponents);

Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted(el) {
  // 聚焦元素
    el.focus();
  },
});


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
